import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './auth/ProtectedRoute';
import ModuleRoute from './auth/ModuleRoute';
import CapabilityRoute from './auth/CapabilityRoute';
import AppShell from './components/layout/AppShell';
import Login from './pages/auth/Login';
import HomeEntry from './pages/HomeEntry';
import Dashboard from './pages/Dashboard';
import Lancamentos from './pages/Lancamentos';
import LancamentosEdicaoLote from './pages/LancamentosEdicaoLote';
import ConciliacaoBancaria from './pages/ConciliacaoBancaria';
import Empresa from './pages/cadastros/Empresa';
import ContasBancarias from './pages/cadastros/ContasBancarias';
import PlanoContas from './pages/cadastros/PlanoContas';
import CentroCustos from './pages/cadastros/CentroCustos';
import DREEstrutura from './pages/cadastros/DREEstrutura';
import MapeamentosExtrato from './pages/cadastros/MapeamentosExtrato';
import DRE from './pages/relatorios/DRE';
import DreVisaoGeral from './pages/relatorios/DreVisaoGeral';
import DreComparativa from './pages/relatorios/DreComparativa';
import DreAnalitico from './pages/relatorios/DreAnalitico';
import ConferenciaSaldo from './pages/relatorios/ConferenciaSaldo';
import OrcadoRealizado from './pages/relatorios/OrcadoRealizado';
import FluxoCaixaProjetado from './pages/relatorios/FluxoCaixaProjetado';
import FechamentoMensal from './pages/relatorios/FechamentoMensal';
import AgingPagarReceber from './pages/relatorios/AgingPagarReceber';
import QualidadeDados from './pages/relatorios/QualidadeDados';
import MargemCentroPlano from './pages/relatorios/MargemCentroPlano';
import MovimentacaoPatrimonial from './pages/relatorios/MovimentacaoPatrimonial';
import ForecastRolling from './pages/relatorios/ForecastRolling';
import PainelExecutivo from './pages/relatorios/PainelExecutivo';
import RelatoriosCentral from './pages/relatorios/RelatoriosCentral';
import Relatorios from './pages/relatorios/Relatorios';
import RadarLucroHome from './pages/radarlucro/RadarLucroHome';
import RupturaPage from './pages/radarlucro/RupturaPage';
import CapitalParadoPage from './pages/radarlucro/CapitalParadoPage';
import MargemPage from './pages/radarlucro/MargemPage';
import SaudeEstoquePage from './pages/radarlucro/SaudeEstoquePage';
import AcoesPage from './pages/radarlucro/AcoesPage';
import ComparativoPage from './pages/radarlucro/ComparativoPage';
import QuedaGiroPage from './pages/radarlucro/QuedaGiroPage';
import EvolucaoRadarPage from './pages/radarlucro/EvolucaoRadarPage';
import ValorCapturadoPage from './pages/radarlucro/ValorCapturadoPage';
import ConstrutorHome from './pages/construtor/ConstrutorHome';
import ConstrutorObrasPage from './pages/construtor/ConstrutorObrasPage';
import ConstrutorOrcamentosPage from './pages/construtor/ConstrutorOrcamentosPage';
import ConstrutorLancamentosPage from './pages/construtor/ConstrutorLancamentosPage';
import ConstrutorVendasPage from './pages/construtor/ConstrutorVendasPage';
import ConstrutorIndicadoresPage from './pages/construtor/ConstrutorIndicadoresPage';
import ConstrutorContasContabeisPage from './pages/construtor/ConstrutorContasContabeisPage';
import ConstrutorCentrosCustoPage from './pages/construtor/ConstrutorCentrosCustoPage';
import ConstrutorPessoasPage from './pages/construtor/ConstrutorPessoasPage';
import ConstrutorContratosPage from './pages/construtor/ConstrutorContratosPage';
import ConstrutorConfiguracoesPage from './pages/construtor/ConstrutorConfiguracoesPage';
import GestaoSaaS from './pages/admin/GestaoSaaS';
import PlanoPagamento from './pages/admin/PlanoPagamento';
import IntegracoesSync from './pages/admin/IntegracoesSync';
import CustomersPage from './pages/core/CustomersPage';
import ChargesPage from './pages/core/ChargesPage';
import ChargeDetailPage from './pages/core/ChargeDetailPage';
import CollectionsRecoveryPage from './pages/core/CollectionsRecoveryPage';
import CollectionsStrategiesPage from './pages/core/CollectionsStrategiesPage';
import CollectionsPromisesPage from './pages/core/CollectionsPromisesPage';
import CollectionsMetricsPage from './pages/core/CollectionsMetricsPage';
import CollectionsChannelsPage from './pages/core/CollectionsChannelsPage';
import SolarPowerPlantsPage from './pages/solar/SolarPowerPlantsPage';
import SolarDashboardPage from './pages/solar/SolarDashboardPage';
import SolarConsumerUnitsPage from './pages/solar/SolarConsumerUnitsPage';
import SolarContractsPage from './pages/solar/SolarContractsPage';
import SolarEnelBillsPage from './pages/solar/SolarEnelBillsPage';
import SolarEnelImportMappingsPage from './pages/solar/SolarEnelImportMappingsPage';
import SolarDocumentsPage from './pages/solar/SolarDocumentsPage';
import SolarSettingsPage from './pages/solar/SolarSettingsPage';
import PersonalFinanceLayout from './modules/personalFinance/components/PersonalFinanceLayout';
import PersonalFinanceHomePage from './modules/personalFinance/pages/PersonalFinanceHomePage';
import PersonalFinanceCashflowPage from './modules/personalFinance/pages/PersonalFinanceCashflowPage';
import PersonalFinanceInsightsPage from './modules/personalFinance/pages/PersonalFinanceInsightsPage';
import PersonalFinanceNotificationsPage from './modules/personalFinance/pages/PersonalFinanceNotificationsPage';
import PersonalFinanceWealthPage from './modules/personalFinance/pages/PersonalFinanceWealthPage';
import PersonalFinanceAccountsPage from './modules/personalFinance/pages/PersonalFinanceAccountsPage';
import PersonalFinanceCardsPage from './modules/personalFinance/pages/PersonalFinanceCardsPage';
import PersonalFinanceGoalsPage from './modules/personalFinance/pages/PersonalFinanceGoalsPage';
import PersonalFinanceConnectionsPage from './modules/personalFinance/pages/PersonalFinanceConnectionsPage';
import PersonalFinanceSettingsPage from './modules/personalFinance/pages/PersonalFinanceSettingsPage';
import PersonalFinanceWeeklyReviewPage from './modules/personalFinance/pages/PersonalFinanceWeeklyReviewPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<AppShell />}>
            <Route path="/" element={<HomeEntry />} />
            <Route element={<ModuleRoute modulo="radar_lucro" fallback="/" />}>
              <Route path="/radar-lucro" element={<RadarLucroHome />} />
              <Route path="/radar-lucro/ruptura" element={<RupturaPage />} />
              <Route path="/radar-lucro/capital-parado" element={<CapitalParadoPage />} />
              <Route path="/radar-lucro/margem" element={<MargemPage />} />
              <Route path="/radar-lucro/saude-estoque" element={<SaudeEstoquePage />} />
              <Route path="/radar-lucro/acoes" element={<AcoesPage />} />
              <Route path="/radar-lucro/queda-giro" element={<QuedaGiroPage />} />
              <Route path="/radar-lucro/comparativo" element={<ComparativoPage />} />
              <Route path="/radar-lucro/evolucao" element={<EvolucaoRadarPage />} />
              <Route path="/radar-lucro/valor-capturado" element={<ValorCapturadoPage />} />
            </Route>

            <Route element={<ModuleRoute modulo="financeiro" fallback="/" />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/conciliacao-bancaria" element={<ConciliacaoBancaria />} />
              <Route path="/lancamentos/edicao-lote" element={<LancamentosEdicaoLote />} />
              <Route path="/lancamentos/importar" element={<Lancamentos />} />
              <Route path="/lancamentos" element={<Lancamentos />} />
              <Route path="/relatorios/dre" element={<DRE />} />
              <Route path="/relatorios/dre-comparativa" element={<DreComparativa />} />
              <Route path="/relatorios/dre-analitico" element={<DreAnalitico />} />
              <Route path="/relatorios/conferencia-saldo" element={<ConferenciaSaldo />} />
              <Route path="/relatorios/orcado-realizado" element={<OrcadoRealizado />} />
              <Route path="/relatorios/fluxo-caixa-projetado" element={<FluxoCaixaProjetado />} />
              <Route path="/relatorios/fechamento-mensal" element={<FechamentoMensal />} />
              <Route path="/relatorios/aging-pagar-receber" element={<AgingPagarReceber />} />
              <Route path="/relatorios/qualidade-dados" element={<QualidadeDados />} />
              <Route path="/relatorios/margem-centro-plano" element={<MargemCentroPlano />} />
              <Route path="/relatorios/movimentacao-patrimonial" element={<MovimentacaoPatrimonial />} />
              <Route path="/relatorios/forecast-rolling" element={<ForecastRolling />} />
              <Route path="/relatorios/painel-executivo" element={<PainelExecutivo />} />
              <Route path="/relatorios/dashboard-avancado" element={<Relatorios />} />
              <Route path="/relatorios" element={<RelatoriosCentral />} />
              <Route path="/relatorios/dre-visao-geral" element={<DreVisaoGeral />} />
            </Route>

            <Route element={<CapabilityRoute capability="billing_core" fallback="/" />}>
              <Route path="/clientes" element={<CustomersPage />} />
              <Route path="/cobrancas" element={<ChargesPage />} />
              <Route path="/cobrancas/:id" element={<ChargeDetailPage />} />
            </Route>

            <Route element={<CapabilityRoute capability="collections" fallback="/" />}>
              <Route path="/cobrancas/recuperacao" element={<CollectionsRecoveryPage />} />
              <Route path="/cobrancas/recuperacao/estrategias" element={<CollectionsStrategiesPage initialSection="policies" />} />
              <Route path="/cobrancas/recuperacao/templates" element={<CollectionsStrategiesPage initialSection="templates" />} />
              <Route path="/cobrancas/recuperacao/canais" element={<CollectionsChannelsPage />} />
              <Route path="/cobrancas/recuperacao/acordos" element={<CollectionsPromisesPage />} />
              <Route path="/cobrancas/recuperacao/metricas" element={<CollectionsMetricsPage />} />
            </Route>

            <Route element={<ModuleRoute modulo="solar" fallback="/" />}>
              <Route path="/solar/dashboard" element={<SolarDashboardPage />} />
              <Route path="/solar/usinas" element={<SolarPowerPlantsPage />} />
              <Route path="/solar/unidades" element={<SolarConsumerUnitsPage />} />
              <Route path="/solar/contratos" element={<SolarContractsPage />} />
              <Route path="/solar/faturas-enel" element={<SolarEnelBillsPage />} />
              <Route path="/solar/mapeamentos-enel" element={<SolarEnelImportMappingsPage />} />
              <Route path="/solar/documentos" element={<SolarDocumentsPage />} />
              <Route path="/solar/configuracoes" element={<SolarSettingsPage />} />
            </Route>

            <Route element={<ModuleRoute modulo="personal_finance" fallback="/" />}>
              <Route element={<PersonalFinanceLayout />}>
                <Route path="/pessoal" element={<Navigate to="/pessoal/inicio" replace />} />
                <Route path="/pessoal/inicio" element={<PersonalFinanceHomePage />} />
                <Route path="/pessoal/caixa" element={<PersonalFinanceCashflowPage />} />
                <Route path="/pessoal/alertas" element={<PersonalFinanceNotificationsPage />} />
                <Route path="/pessoal/insights" element={<PersonalFinanceInsightsPage />} />
                <Route path="/pessoal/patrimonio" element={<PersonalFinanceWealthPage />} />
                <Route path="/pessoal/contas" element={<PersonalFinanceAccountsPage />} />
                <Route path="/pessoal/cartoes" element={<PersonalFinanceCardsPage />} />
                <Route path="/pessoal/metas" element={<PersonalFinanceGoalsPage />} />
                <Route path="/pessoal/revisao-semanal" element={<PersonalFinanceWeeklyReviewPage />} />
                <Route path="/pessoal/conexoes" element={<PersonalFinanceConnectionsPage />} />
                <Route path="/pessoal/ajustes" element={<PersonalFinanceSettingsPage />} />
              </Route>
            </Route>

            <Route element={<CapabilityRoute capability="master_data" fallback="/" />}>
              <Route path="/cadastros/empresa" element={<Empresa />} />
              <Route path="/cadastros/contas-bancarias" element={<ContasBancarias />} />
              <Route path="/cadastros/plano-contas" element={<PlanoContas />} />
              <Route path="/cadastros/centro-custos" element={<CentroCustos />} />
              <Route path="/cadastros/dre-estrutura" element={<DREEstrutura />} />
              <Route path="/cadastros/mapeamentos-extrato" element={<MapeamentosExtrato />} />
              <Route path="/cadastros/construtor-contas-contabeis" element={<ConstrutorContasContabeisPage />} />
              <Route path="/cadastros/construtor-centros-custo" element={<ConstrutorCentrosCustoPage />} />
              <Route path="/construtor/contas-contabeis" element={<Navigate to="/cadastros/construtor-contas-contabeis" replace />} />
              <Route path="/construtor/centros-custo" element={<Navigate to="/cadastros/construtor-centros-custo" replace />} />
            </Route>

            <Route element={<ModuleRoute modulo="construtor" fallback="/" />}>
              <Route path="/construtor" element={<ConstrutorHome />} />
              <Route path="/construtor/obras" element={<ConstrutorObrasPage />} />
              <Route path="/construtor/orcamentos" element={<ConstrutorOrcamentosPage />} />
              <Route path="/construtor/lancamentos" element={<ConstrutorLancamentosPage />} />
              <Route path="/construtor/vendas" element={<ConstrutorVendasPage />} />
              <Route path="/construtor/indicadores" element={<ConstrutorIndicadoresPage />} />
              <Route path="/construtor/pessoas" element={<ConstrutorPessoasPage />} />
              <Route path="/construtor/contratos" element={<ConstrutorContratosPage />} />
              <Route path="/construtor/configuracoes" element={<ConstrutorConfiguracoesPage />} />
              <Route path="/cadastros/configuracao-operacional" element={<ConstrutorConfiguracoesPage />} />
            </Route>

            <Route path="/admin/gestao" element={<GestaoSaaS />} />
            <Route path="/admin/plano-pagamento" element={<PlanoPagamento />} />
            <Route path="/admin/integracoes" element={<IntegracoesSync />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </Router>
  );
}

export default App;
